<template>
  <div class="inputtotal">
    <div class="field is-fullwidth has-addons">
      <div class="control is-expanded has-icons-left">
        <input
          class="input is-fullwidth is-primary"
          v-model="inputRegtotal"
          id="inputRegtotal"
          type="text"
          autocomplete="off"
          @keydown="keyfunction($event)"
        />
        <span v-show="editsel" class="icon is-small is-left">
          <i class="material-icons">edit</i>
        </span>
        <span v-show="!editsel" class="icon is-small is-left">
          <i class="material-icons">control_camera</i>
        </span>
      </div>
      <div class="control">
        <a class="button is-primary" @click="ok">
          <span class="icon is-medium">
            <i class="material-icons">done_outline</i>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      editsel: false,
      inputRegtotal: ""
    };
  },
  props: {
    filatotal: Number,
    fila: Number,
    lengthRegtotal: Number,
    lengthReg: Number,
    index: Number,
    reg: Array
  },
  methods: {
    chargeData(f) {
      this.inputRegtotal = this.reg[f].valor;
    },
    ok() {
      if (this.filatotal < this.lengthRegtotal - 1) {
        this.$emit("filatotal", this.filatotal + 1);
        setTimeout(function() {
          document.getElementById("inputRegtotal").focus();
        }, 5);
      }
    },
    keyfunction(e) {
      if (e.keyCode === 121) {
        e.preventDefault();
        this.$emit("f10guardar");
      }
      if (e.keyCode === 113) {
        e.preventDefault();
        if (this.editsel) {
          this.editsel = false;
        } else {
          this.editsel = true;
        }
      }
      if (e.keyCode === 40) {
        if (!this.editsel) {
          e.preventDefault();
          console.log(this.filatotal, this.lengthRegtotal);
          if (this.filatotal < this.lengthRegtotal - 1) {
            this.$emit("filatotal", this.filatotal + 1);
            setTimeout(function() {
              document.getElementById("inputRegtotal").focus();
            }, 5);
          }
        }
      }
      if (e.keyCode === 38) {
        if (!this.editsel) {
          e.preventDefault();
          if (this.filatotal > 0) {
            this.$emit("filatotal", this.filatotal - 1);
            setTimeout(function() {
              document.getElementById("inputRegtotal").focus();
            }, 5);
          } else if (this.filatotal === 0) {
            this.$emit("fila", this.lengthReg - 1);
            setTimeout(function() {
              document.getElementById("inputReg").focus();
            }, 5);
          }
        }
      }
      if (e.keyCode === 13 || e.keyCode === 9) {
        // que haga lo mismo con el tabulador y el enter
        e.preventDefault();
        this.ok();
      }
    }
  },
  watch: {
    inputRegtotal(newv, oldv) {
      this.$emit("changeInputRegtotal", {
        filatotal: this.filatotal,
        data: newv
      });
    }
  },
  created() {
    this.chargeData(this.filatotal); // no se pone en un watcher porque el componente se crea cada que se cambia de fila
    setTimeout(function() {
      document.getElementById("inputRegtotal").select();
    }, 5);
  }
};
</script>

<style lang="scss" scoped>
.inputtotal {
  margin-top: -18px;
  width: 80% !important;
  margin-left: 10% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/registrar/Formregistrototal2.vue